import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FileUploader} from 'ng2-file-upload';
import {HttpService} from '../../../services/http.service';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-e4n-upload',
  templateUrl: './e4n-upload.component.html',
  styleUrls: ['./e4n-upload.component.css']
})
export class E4nUploadComponent implements OnInit {

  uploadForm: UntypedFormGroup;
  uploader: FileUploader = new FileUploader({url: environment.baseUrl + '/upload/e4n'});
  latestDate: string;

  constructor(private fb: UntypedFormBuilder, private http: HttpService, private sweetUtil: SweetUtil) {
  }

  ngOnInit(): void {
    this.uploadForm = this.fb.group({
      document: [null, null],
      type: [null, Validators.compose([Validators.required])]
    });
    this.fetchLatestDate();
  }

  fetchLatestDate() {
    this.http.fetchLatestE4nDate().subscribe((res: any) => {
      this.latestDate = res.latestDate;
    });
  }

  uploade4nFiles() {
    let files = new FormData();
    for (let i = 0; i < this.uploader.queue.length; i++) {
      const fileItem = this.uploader.queue[i]._file;
      if (fileItem.size > 10000000) {
        alert('Each File should be less than 10 MB of size.');
        return;
      }
    }

    for (let j = 0; j < this.uploader.queue.length; j++) {
      const fileItem = this.uploader.queue[j]._file;
      files.append('file', fileItem);
      files.append('fileSeq', 'seq' + j);
      files.append('dataType', this.uploadForm.controls.type.value);
    }

    this.http.postE4nFile(files).subscribe(() => {
      this.uploader.clearQueue();
      SweetUtil.showSuccess('Source Data Saved').then();
    }, err => {
      if (err.status === 406) {
        SweetUtil.showWarning('This file was found to be invalid and has not been saved.').then();
      } else {
        console.error(err);
        this.sweetUtil.showError('There was a problem saving this file. Please try again.').then();
        console.error(JSON.stringify(err));
      }
    });
  }

  goBack() {
    window.history.back();
  }

}
